// components/atoms/Card/CustomCard.tsx
import React, { forwardRef } from 'react';
import styles from '@/components/atoms/CustomCard/customCard.module.css';

interface AtomCustomCardProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  onClick?: () => void;
  className?: string;
}

const AtomCustomCard = forwardRef<HTMLDivElement, AtomCustomCardProps>(
  ({ children, onClick, className = '', ...props }, ref) => {
    const baseClassName = `
    ${styles.atomCard} 
    ${onClick ? styles.clickable : ''} 
    ${className}
  `.trim();

    return (
      <div ref={ref} className={baseClassName} onClick={onClick} {...props}>
        {children}
      </div>
    );
  }
);

AtomCustomCard.displayName = 'AtomCustomCard';

export default AtomCustomCard;
